import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'tebitasks-initials-display',
  imports: [],
  templateUrl: './initials-display.component.html',
  styleUrl: './initials-display.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InitialsDisplayComponent {

  givenName = input.required<string|null|undefined>();
  familyName = input.required<string|null|undefined>();
  initials = computed(() => {
    let initials = '';
    if (this.givenName() && this.givenName()!.length > 0) {
      initials += this.givenName()!.substring(0, 1).toUpperCase();
    }
    if (this.familyName() && this.familyName()!.length > 0) {
      initials += this.familyName()!.substring(0, 1).toUpperCase();
    }
    if (initials.length === 0) {
      initials = '?';
    }
    return initials;
  });

}
